import { concatClassnames } from "shared/utils/concatClassnames";
import { error_animation } from "widgets/checkout/send-to-email/components/Textinput";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";

interface InputProps {
  id?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  type?: string;
  placeholder?: string;
  className?: string;
  required?: boolean;
  readOnly?: boolean;
  value?: string;
  suffix?: string;
  error?: boolean;
  min?: number;
  max?: number;
  step?: string;
  errorText?: string;
}

// TODO: Remove attributes from props, and use rest param instead
const Input = ({
  placeholder = "",
  className,
  id,
  required = false,
  readOnly = false,
  onChange,
  onBlur,
  onFocus,
  error,
  errorText,
  value,
  type,
  step = "1",
  suffix,
  ...rest
}: InputProps) => {
  return (
    <div className={"gg-flex-grow"}>
      <div className={"gg-relative gg-flex"}>
        <input
          id={id}
          className={concatClassnames(
            "gg-relative gg-flex-grow gg-border gg-border-dark-blue-500 gg-px-3 gg-py-2 gg-text-sm",
            "gg-items gg-rounded-sm gg-text-dark-blue placeholder:gg-text-dark-blue-800",
            "read-only:gg-bg-grey-600",
            error
              ? "gg-border-red-600 focus:gg-border-red-600 focus:gg-ring-red-600"
              : "",
            className,
            `gg-form-${type ?? "input"}`,
          )}
          type={type}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          value={value}
          step={step}
          {...rest}
        />
        {suffix ? (
          <span
            className={
              "gg-absolute gg-right-4 gg-top-1/2 gg-block -gg-translate-y-1/2 gg-text-gray-500"
            }
          >
            {suffix}
          </span>
        ) : null}
      </div>

      <div className="gg-my-0.5 gg-h-1">
        <AnimatePresence mode="wait" initial={false}>
          {error && (
            <motion.p
              {...error_animation}
              className="gg-text-xs gg-font-semibold gg-italic gg-text-red-500"
              role="alert"
              data-testid="input-validation-error"
            >
              {errorText}
            </motion.p>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
export default Input;
